import { useEffect, useState } from 'react';
import { useAccessLevelContext } from 'src/auth/context/access-level-context';
import { getRole } from 'src/auth/context/jwt/utils';
import { ViewPermission } from 'src/auth/types';
import axios, { endpoints } from 'src/utils/axios';

export const removeNoAuth = (data: any, permissions: ViewPermission[]) => {
  const filteredData = data.map((e: any) => {
    const item = { ...e }.items[0];
    const group = { ...item };

    if (!group.children) {
      const isAuthorized = isAuthorizedView(permissions, group.viewName);
      return isAuthorized ? e : null;
    }

    const children = group.children
      .map((child: any) => {
        return child && isAuthorizedView(permissions, child.viewName)
          ? child
          : null;
      })
      .filter((e: any) => e !== null);

    if (children.length === 0) return null;

    const authElement = { ...e };
    group.children = children;
    authElement.items = [group];
    return authElement;
  });

  return filteredData.filter((e: any) => e !== null);
};

export const isAuthorizedView = (permissions: ViewPermission[], view: string) =>
  permissions.some((p) => p.description === view && p.isAllowed);

export const useInitializePermissions = () => {
  const { viewPermissions, loadingPermissions } = useAccessLevelContext();

  useEffect(() => {
    if (loadingPermissions) {
      return;
    }
  }, [viewPermissions, loadingPermissions]);

  return viewPermissions;
};
